const arrPaths = document.location.pathname.split('/');
const primaryDir = arrPaths[1];
const secondaryDir = arrPaths[2];
const tertiaryDir = arrPaths[3];

export {
    arrPaths,
    primaryDir,
    secondaryDir,
    tertiaryDir
}